export default (context) => {
  return {
      config: {
        pageSize: 10,
        list: false,
        resource:'admOrder/detail',
        hiddenTitle: false
      },
    
      actions: {
        create: true,
        edit: true,
        delete: true
      },

      extras: {
        items: []
      },

      filter: {
        fields: [],
        buttons: []
      },

      form: {
        setValuesBeforePost: (values) => {
          return values
        },
        fields: [
          {
            col: 12,
            name: "item",
            value: "",
            type: "text",
            label: "Concepto",
            rules: 'required',
            opts: {
              style: 'float-label'
            }
          },
          {
            col: 12,
            name: "quantity",
            value: null,
            type: "number",
            label: "Cantidad",
            rules: 'required',
            opts: {
              style: 'float-label'
            }
          },
          {
            col: 12,
            name: "amount",
            value: null,
            type: "number",
            label: "Monto",
            rules: 'required',
            opts: {
              style: 'float-label'
            }
          }
        ]
      },

      columns: [
        {
          Header: "Concepto",
          accessor: "item"
        },{
          Header: "Cantidad",
          accessor: "quantity",
          minWidth: 50
        },{
          Header: "Monto",
          accessor: "amount",
          isDecimal: true,
          minWidth: 50
        }
      ]
  }
}